import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { supabase } from '../lib/supabase'

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const verifyRecaptcha = async (action = 'submit') => {
    if (!executeRecaptcha) {
      console.warn('reCAPTCHA not loaded yet')
      return { success: false, error: 'reCAPTCHA not loaded' }
    }

    try {
      // Get reCAPTCHA token
      const token = await executeRecaptcha(action)

      // Verify token with Supabase Edge Function
      const { data, error } = await supabase.functions.invoke('verify-recaptcha', {
        body: { token }
      })

      if (error) {
        console.error('reCAPTCHA verification error:', error)
        return { success: false, error: error.message }
      }

      return data
    } catch (error) {
      console.error('reCAPTCHA error:', error)
      return { success: false, error: error.message }
    }
  }

  return { verifyRecaptcha }
}
